<template>
    <div>

        <v-layout row justify-center>
            <v-dialog  v-model="mustShowActivationCodePopup"  persistent max-width="70%" class="popup-scoring" id="close-label-popupp">
                <v-card class="popup-scoring">
                    <v-card-title class="headline" >
                        <span class="font-weight-light" color="primary">{{text('db.global.TYPE_GTS_ACTIVATIONCODE_TITLE_B')}}</span>
                        <span  @click="hideActivationCodePopup()" class="float-right">
                            <close-icon />
                        </span>
                    </v-card-title>
                    <v-card-text>
                            <v-flex xs12>
                                <div >
                                    <h3>{{text('db.global.TYPE_GTS_ACTIVATIONCODE_TITLE_A')}}</h3><br/>
                                    <p v-html="text('db.global.TYPE_GTR_PAGE_ACTIVATIONCODE_TEXTFIELD_1')"></p>
                                </div>
                            </v-flex>
                            <v-flex lg12 xl6 class="input-code">
                                <v-text-field
                                    v-model="value"
                                    solo
                                    :label="text('api.activationcode.activate.placeholder')"
                                    :append-icon="(value && value.length > 0) ? 'clear' : ''"
                                    :append-icon-cb="clearValue"
                                    id="input-search-code"
                                    focusable
                                ></v-text-field>
                                <span v-if="mustShowTryAgainInvalid && value" class="pulsate">{{text('api.error.activation.code.invalid')}}</span>
                                <span v-if="mustShowTryAgainActivated && value" class="pulsate">{{text('api.error.activation.code.activated')}}</span>
                                <span v-if="mustShowTryAgainExpired && value" class="pulsate">{{text('api.error.activation.code.expired')}}</span>
                            </v-flex>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="addActivationCode()" class="activate-button" :disabled="!value" color="primary">{{text('api.activationcode.activate')}}</v-btn>
                        <v-btn flat :ripple="false" @click="hideActivationCodePopup()">{{ text('api.button.cancel') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapActions, mapGetters} from 'vuex';
    import axios from 'axios';
    import Vue from "vue";
    import CloseIcon from "../svg/shared/closeIcon";

    export default {
        name: 'ActivationCodePopup',
        components: {CloseIcon},
        data () {
            return {
                value: '',
                validated: false,
                clearRedPfPlugin: Vue.ClearRedPf.clearRedPfSvg
            }
        },
        computed: {
            ...mapGetters({
                mustShowActivationCodePopup: 'ProductListStore/getMustShowActivationCodePopup',
                mustShowTryAgainInvalid: 'ProductListStore/getMustShowTryAgainInvalid',
                mustShowTryAgainExpired: 'ProductListStore/getMustShowTryAgainExpired',
                mustShowTryAgainActivated: 'ProductListStore/getMustShowTryAgainActivated',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getGuiThemeColor: 'TranslationStore/getAppPropertyValue'
            }),
        },
        methods: {
            ...mapActions({
                showActivationCodePopup: 'ProductListStore/showActivationCodePopup'
            }),

            hideActivationCodePopup() {
                this.$store.commit('ProductListStore/setMustShowActivationCodePopup', false);
                this.$store.commit('ProductListStore/setMustShowTryAgainInvalid', false);
                this.$store.commit('ProductListStore/setMustShowTryAgainExpired', false);
                this.$store.commit('ProductListStore/setMustShowTryAgainActivated', false);
                this.value = '';
            },
            escapeKeyListener: function(evt) {
                if (evt.keyCode === 27) {
                    this.hideActivationCodePopup();
                }
            },
            addActivationCode() {
                const currentUrl = window.location.hash;
                let result = /(\/)([a-zA-Z\-\_]*)/.exec(currentUrl);
                const currentPage = result[2];

                let axiosRequest = axios.post(process.env.API_BASE_URL + '/validateActivationCode', {
                    value: this.value
                });

                axiosRequest.then((response) => {
                    let responseCode = response.data.returnCode;
                    if (responseCode === 0) {
                        this.hideActivationCodePopup();

                        if (currentPage === 'pathfinder') {
                            this.$store.dispatch('PfProductListStore/loadProductListPageData');
                        }
                        else {
                            this.$store.dispatch('ProductListStore/loadProductListPageData');
                        }
                    }
                    else if (responseCode === 106) {
                        this.$store.commit('ProductListStore/setMustShowTryAgainInvalid', true);
                    }
                    else if (responseCode === 107) {
                        this.$store.commit('ProductListStore/setMustShowTryAgainActivated', true);
                    }
                    else if (responseCode === 108) {
                        this.$store.commit('ProductListStore/setMustShowTryAgainExpired', true);
                    }

                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            },
            clearValue(){
                this.value='';
                document.getElementById('input-search-code').focus();
            }
        },

        watch: {
            value(newVal, oldVal) {

                let inputCode = document.getElementById('input-search-code').value.length;
                let that = this;
                setTimeout(function() {
                    let searchSymptomInput = document.querySelector('.popup-scoring .input-group');
                    if (inputCode > 0) {
                        if (searchSymptomInput) {
                            let clearSearchSymptomIcon = searchSymptomInput.getElementsByClassName('input-group__append-icon');
                            if (clearSearchSymptomIcon.length > 0) {
                                clearSearchSymptomIcon[0].innerHTML = that.clearRedPfPlugin();
                            }
                        }
                    }
                }, 1);

                if (newVal || oldVal == null) {
                    this.$store.commit('ProductListStore/setMustShowTryAgainInvalid', false);
                    this.$store.commit('ProductListStore/setMustShowTryAgainExpired', false);
                    this.$store.commit('ProductListStore/setMustShowTryAgainActivated', false);
                }
            }
        },
        created: function() {
            document.addEventListener('keyup', this.escapeKeyListener);
        },
        destroyed: function() {
            document.removeEventListener('keyup', this.escapeKeyListener);
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .popup-scoring {

        &.card {
            padding: 0;

            .card__title {
                background-color: $color-brand-primary;
                display: block;
                color: $color-on-primary;
                padding: 20px 40px;

                .icon {

                    &:hover {
                        cursor: pointer;
                    }

                }
            }

            .card__text {
                padding: 40px;
            }

            .card__actions {
                background: $color-elevation-background;
                padding: 15px 40px;
                .btn:not(.activate-button) {
                    border: 1px solid $color-element-outline;
                }
                .btn.activate-button {
                    color: $color-on-primary;
                }
            }

        }

        p {
            font-size: $font-size-small;
            color: $color-headings-text;
            margin-bottom: 0;
        }

        .ambulance-scoring {
            position: relative;
            top: 7px;
            right: 7px;
        }
    }

    .input-code {
        position: relative;
        margin-top: 20px;

        span {
            color: $color-brand-primary;
            position: absolute;
            margin-top: 2px;
        }
    }

    .pulsate {
        -webkit-animation: pulsate 1s ease-out;
        -webkit-animation-iteration-count: 1;
        opacity: 1;
    }

    @-webkit-keyframes pulsate {
        0% {
            opacity: 0.5;
            font-size: $font-size-small;
        }

        50% {
            opacity: 0.8;
            font-size: $font-size-default;
        }

        100% {
            opacity: 1;
            font-size: $font-size-medium;
        }
    }

</style>




// WEBPACK FOOTER //
// src/common/components/shared/ActivationCodePopup.vue